import FollowUpMeeting from './FollowUpMeeting';

export default FollowUpMeeting;